export default __webpack_public_path__ + "static/media/Brigand's Belt of the Howling Wind.396afc41.jpg";